import { isWindowActiveNow } from '../../util/scheduleUtil';
import { ScheduleVersionInfo } from '../../model/schedulingModels/ScheduleVersionInfo';

export enum RequestVersionStatus {
  /** The request is part of an active version */
  ACTIVE = 'ACTIVE',
  /** The request is part of an expired version */
  EXPIRED = 'EXPIRED',
  /** The request is part of a version scheduled to start in the future */
  FUTURE = 'FUTURE',
}

const from = ({ activeFrom, activeTo }: ScheduleVersionInfo): RequestVersionStatus => {
  const now = Date.now();
  if (activeFrom.unixTimeMillis > now) {
    return RequestVersionStatus.FUTURE;
  } else if (isWindowActiveNow({ windowStart: activeFrom, windowEnd: activeTo })) {
    return RequestVersionStatus.ACTIVE;
  } else {
    return RequestVersionStatus.EXPIRED;
  }
};

export const RequestVersionStatuses = {
  from,
};
